/**
 * Translation configuration for i18n
 */

import { BehaviorSubject } from 'rxjs';
import { getCurrentEnv } from '../utils/utils';

// Translation experience ID for the manage family app
export const TRANSLATION_EXPERIENCE_ID = '76a35525-1743-4ccd-bdd4-d10aad047e79';

// API Keys
const LOWER_ENV_TRANSLATION_KEY = 'PRX4fYhAfVTr3UH3tSOTlb9oYNrAPUjA';
const PROD_ENV_TRANSLATION_KEY = 'HGNLXaQhG8CtglhHBvA7XD2TFnso1Scx';

// Translation API base path
const RETAIL_TRANSLATE_API_URI = '/api/client/experience/v2/load';

/**
 * Get translation API key based on environment
 * @returns BehaviorSubject with API key
 */
export const getTranslateApiKey = (): BehaviorSubject<string | null> => {
  const currentEnv = getCurrentEnv();
  const apiKey = currentEnv === 'PROD' || currentEnv === 'PROD-ES' ? PROD_ENV_TRANSLATION_KEY : LOWER_ENV_TRANSLATION_KEY;
  return new BehaviorSubject<string | null>(apiKey);
};

/**
 * Get translation API URL
 * @returns BehaviorSubject with full API URL
 */
export const getTranslateApiUrl = (): BehaviorSubject<string | null> => {
  const url = `${RETAIL_TRANSLATE_API_URI}/${TRANSLATION_EXPERIENCE_ID}`;
  return new BehaviorSubject<string | null>(url);
};
